export const sortStringBasic = (a: string, b: string, ascendingOrder: boolean) => {
  const fa = ascendingOrder ? a : b;
  const fb = ascendingOrder ? b : a;

  return fa < fb ? -1 : fa > fb ? 1 : 0;
};

const collator = new Intl.Collator('sv', { sensitivity: 'base' });

export const sortStringLocale = (a: string, b: string, ascendingOrder: boolean) => {
  const fa = ascendingOrder ? a : b;
  const fb = ascendingOrder ? b : a;

  // Make sure swedish characters (Å, Ä and Ö) are sorted correctly
  // using collator which is faster than localCompare but still slower than the regular search (doesn't support locale).
  return collator.compare(fa, fb);
};

export const sortNumber = (a: number, b: number, ascendingOrder: boolean) => {
  const fa = ascendingOrder ? a : b;
  const fb = ascendingOrder ? b : a;

  return fa - fb;
};

export const sortBoolean = (a: boolean, b: boolean, ascendingOrder: boolean) => {
  const fa = ascendingOrder ? a : b;
  const fb = ascendingOrder ? b : a;

  return fa && !fb ? -1 : !fa && fb ? 1 : 0;
};

export const sortBooleanAndStringBasic = (
  a: { bool: boolean; stringBasic: string },
  b: { bool: boolean; stringBasic: string },
  ascendingOrder: boolean
) => {
  const fa = ascendingOrder ? a : b;
  const fb = ascendingOrder ? b : a;

  return fb.bool && !fa.bool
    ? -1
    : !fb.bool && fa.bool
    ? 1
    : 0 || fa.stringBasic < fb.stringBasic
    ? -1
    : fa.stringBasic > fb.stringBasic
    ? 1
    : 0;
};

export const sortKeyInactive = 'isInactive';
export const sortKeyHasParams = 'hasFokParameterChoices';
export const sortKeyNone = 'none';
type InactiveOrFokParameterChoices = typeof sortKeyInactive | typeof sortKeyHasParams | typeof sortKeyNone;

export const sortInactiveOrHasDeviation = (
  a: InactiveOrFokParameterChoices,
  b: InactiveOrFokParameterChoices,
  ascendingOrder: boolean
): 1 | -1 | 0 => {
  const fa = ascendingOrder ? a : b;
  const fb = ascendingOrder ? b : a;

  if (fa === fb) {
    return 0;
  }
  if ((fa === sortKeyHasParams && fb === sortKeyInactive) || fa === sortKeyNone) {
    return 1;
  }
  return -1; // fa === sortKeyInactive || (fa === sortKeyHasParams && fb === sortKeyNone)
};
